import React from "react";
import "./form-layout.css";

export default function FormPage({ children, className = "", density = "normal" }) {
  return <div className={`page-content admin-form ${className}`} data-density={density}>{children}</div>;
}
